import { render } from "./NeedSupportComponent.vue?vue&type=template&id=f8582bbe&ts=true"
import script from "./NeedSupportComponent.ts?vue&type=script&lang=ts"
export * from "./NeedSupportComponent.ts?vue&type=script&lang=ts"

import "./NeedSupportComponent.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__